import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Service worker disabled - app works as regular website
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
//     
//     navigator.serviceWorker
//       .register(swUrl)
//       .then((registration) => {
//         console.log('✅ Service Worker registered:', registration);
//         
//         // Check for updates every 60 seconds
//         setInterval(() => {
//           registration.update();
//         }, 60000);
//       })
//       .catch((error) => {
//         console.warn('⚠️ Service Worker registration failed:', error);
//       });
//   });
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hide splash screen after React has rendered
setTimeout(() => {
  document.body.classList.add('app-loaded');
  // Remove splash screen from DOM after fade out
  setTimeout(() => {
    const splash = document.getElementById('splash-screen');
    if (splash) {
      splash.remove();
    }
  }, 500);
}, 100);